import { Factory } from '../Factory';
import { Service } from '../Service';
import { IConfigService } from '../config';
import { IHttpWrapperService } from '../http';
import { ResourceWrapperService } from '../utilities/ResourceWrapperService';

export class ReviewService extends Service<any> {
  private configService: IConfigService;
  private httpService: IHttpWrapperService;

  constructor(resource: any, rootScope: IRootScope, httpService: IHttpWrapperService, configService: IConfigService, resourceWrapperService: ResourceWrapperService) {
    super({resource, rootScope, resourceWrapperService});

    this.httpService = httpService;
    this.configService = configService;

    let projectBillingResource = this.resource(`${configService.getServerBaseUrlForResource()}/review/:id`,
      {id: '@id'}
    );

    this.itemResource = this.resourceWrapperService.WrapActions(projectBillingResource);
  }

  public async GetReviewStatistics(projectId: string) {
    let url = `${this.configService.getServerBaseUrl()}/review/${projectId}`;

    const response = await this.httpService.$http({
      method: 'GET',
      url: url
    });

    return response.data;
  }

}

frontendApp.factory("ReviewService", ["$resource", "$rootScope", "HttpService", "ConfigService", "ResourceWrapperService", Factory.Create(ReviewService)]);
